import { useMemo } from 'react';
import { useLocation } from 'react-router';

import { useIsClient } from '#/hooks/useIsClient';
import type { DatetimeString } from '#/types/TypedDateString';

type Props = {
  serverNow: DatetimeString;
};

/**
 * Used in pages such as search where `now` is consumed
 * in the client, after results arrive.
 */
export function useClientNow({ serverNow }: Props) {
  const isClient = useIsClient();
  const location = useLocation();

  const clientNow = useMemo(
    () => (isClient ? new Date().toISOString() : serverNow),
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    [
      serverNow,
      // We want to key by location.key so that navigating updates "now"
      location.key,
    ],
  );

  return { clientNow };
}
